<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          name="name"
          :value="value.title"
          :counter="40"
          :rules="rules.title"
          :readonly="readonly"
          :error-messages="errors.title"
          :label="`${$t('ITEM.TITLE')} *`"
          @input="updateValue('title', $event)"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <slot name="buttons" :valid="valid" />
    </v-row>
  </div>
</template>

<script>
import { maxLength, notEmpty } from '@/modules/_global/variables/rules';
import formEditable from '@/modules/_global/mixins/form-editable';

export default {
  name: 'ItemTranslationForm',

  mixins: [formEditable],

  props: {
    languageId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      valid: true,
      rules: {
        title: [notEmpty, maxLength(40)]
      }
    };
  },

  mounted() {
    this.$emit('input', { ...this.value, language_id: this.languageId });
  },

  methods: {
    updateValue(key, value) {
      this.$emit('update-prop', key, value);
      this.$emit('input', {
        ...this.value,
        language_id: this.languageId,
        [key]: value
      });
    }
  }
};
</script>
